import { GettingStartedStoreAccess } from "../../store";

export function useGetThemeName() {
  const themes = GettingStartedStoreAccess.useThemes();

  return (themeId: string) => {
    const chosenTheme = themes.find(theme => String(theme.id) === themeId);

    return chosenTheme?.name;
  };
}
